"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINWAY_LEGAL_DATA = exports.CSV_EMPTY_VALUE = exports.COLLECTIONS_WITH_CHANGE_HISTORY = exports.DEFAULT_CSV_DECIMAL_SEPARATOR = exports.CHANGE_HISTORY_RETENTION_PERIOD_IN_YEARS = exports.DEVICE_ID_COOKIE_FIELD = exports.MIN_ALLOWED_ARCHIVE_AFTER_X_DAYS = exports.MAX_ALLOWED_ARCHIVE_AFTER_X_DAYS = exports.DEFAULT_COMPANY_TRANSACTION_ARCHIVE_AFTER_X_DAYS = exports.DEFAULT_COMPANY_ARCHIVE_AFTER_X_DAYS = exports.DEFAULT_COMPANY_TIMEZONE = exports.PER_DIEM_DINNER_RATE = exports.PER_DIEM_LUNCH_RATE = exports.PER_DIEM_BREAKFAST_RATE = exports.PASSWORD_MIN_ALLOWED_LENGTH = exports.DOCUMENT_SUPPORTED_FORMAT_MAP = exports.supportedInvoiceFormats = exports.supportedDocumentFormats = exports.supportedImageInvoiceFormats = exports.DEFAULT_COMMENT_SPLIT_SYMBOL = exports.SortEnum = exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = exports.TEN_BILLION = exports.PRICE_MIN_BIGGER_THAN = exports.ONE_HUNDRED_MILLION = exports.vendorRecommendations = exports.allowedParsingDateFormats = exports.CalculationIntervals = exports.CurrencySymbol = exports.BudgetPeriods = void 0;
const collectionName_enum_1 = require("../models/activity/collectionName.enum");
const currency_enum_1 = require("../models/common/currency.enum");
const documentType_enum_1 = require("../models/common/documentType.enum");
const userSettings_interface_1 = require("../models/user/userSettings.interface");
const recommendationString_enum_1 = require("../models/vendor/recommendationString.enum");
exports.BudgetPeriods = {
    0: "Monthly",
    1: "Quarterly",
    2: "Yearly",
};
exports.CurrencySymbol = {
    [currency_enum_1.CurrencyEnum.USD]: "$",
    [currency_enum_1.CurrencyEnum.EUR]: "€",
    [currency_enum_1.CurrencyEnum.HUF]: "Ft",
};
exports.CalculationIntervals = {
    0: "Current month",
    1: "Current year",
    2: "All times",
};
exports.allowedParsingDateFormats = [
    // German format
    "DD.MM.YYYY",
    "D.M.YYYY",
    "D.MM.YYYY",
    "DD.M.YYYY",
    "DD. MM. YYYY",
    "DD. M. YYYY",
    "D. MM. YYYY",
    "DD. MM. YY",
    "D. MM. YY",
    "DD. M. YY",
    "D. M. YYYY",
    "DD.MM.YY",
    "YYYY-MM-DD",
    "YYYY-M-D",
    "YYYY-MM-D",
    "YYYY-M-DD",
    "DD-MM-YYYY",
    "DD-M-YYYY",
    "D-MM-YYYY",
    "D-M-YYYY",
    "DD/MM/YYYY",
    "D/M/YYYY",
    "DD/M/YYYY",
    "D/MM/YYYY",
    "DD/MM/YY",
    "D/M/YY",
    "DD/M/YY",
    "D/MM/YY",
    // US format
    // 'MM/DD/YYYY',
    // 'M/D/YYYY',
    // 'MM/D/YYYY',
    // 'M/DD/YYYY',
    // 'MM/DD/YY',
    // 'M/D/YY',
    // 'MM/D/YY',
    // 'M/DD/YY',
    // Japanese / Hungarian format
    "YYYY.MM.DD.",
    "YYYY.MM.DD",
    "YYYY. MM. DD.",
    "YYYY. MM. DD",
];
exports.vendorRecommendations = Object.values(recommendationString_enum_1.RecommendationStringEnum);
exports.ONE_HUNDRED_MILLION = 100000000;
exports.PRICE_MIN_BIGGER_THAN = 0;
exports.TEN_BILLION = 10000000000;
/**
 * In percent.
 */
exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = 3;
var SortEnum;
(function (SortEnum) {
    SortEnum["ASC"] = "asc";
    SortEnum["DESC"] = "desc";
})(SortEnum || (exports.SortEnum = SortEnum = {}));
exports.DEFAULT_COMMENT_SPLIT_SYMBOL = ".";
exports.supportedImageInvoiceFormats = [".jpg", ".jpeg", ".png"];
exports.supportedDocumentFormats = [...exports.supportedImageInvoiceFormats, ".pdf"];
exports.supportedInvoiceFormats = [...exports.supportedDocumentFormats, ".xml"];
exports.DOCUMENT_SUPPORTED_FORMAT_MAP = {
    [documentType_enum_1.DocumentTypeEnum.INVOICE]: exports.supportedInvoiceFormats,
    [documentType_enum_1.DocumentTypeEnum.DELIVERY_NOTE]: exports.supportedDocumentFormats,
    [documentType_enum_1.DocumentTypeEnum.OFFER]: exports.supportedDocumentFormats,
    [documentType_enum_1.DocumentTypeEnum.SPREADSHEET]: exports.supportedDocumentFormats,
    [documentType_enum_1.DocumentTypeEnum.PURCHASE_ORDER]: exports.supportedDocumentFormats,
};
exports.PASSWORD_MIN_ALLOWED_LENGTH = 8;
// TODO FA-161: Refactor and let these values be provided by the backend and store them in redux
exports.PER_DIEM_BREAKFAST_RATE = 0.2;
exports.PER_DIEM_LUNCH_RATE = 0.4;
exports.PER_DIEM_DINNER_RATE = 0.4;
exports.DEFAULT_COMPANY_TIMEZONE = "Europe/Berlin";
exports.DEFAULT_COMPANY_ARCHIVE_AFTER_X_DAYS = 180;
exports.DEFAULT_COMPANY_TRANSACTION_ARCHIVE_AFTER_X_DAYS = 180;
exports.MAX_ALLOWED_ARCHIVE_AFTER_X_DAYS = 730; // 2 years
exports.MIN_ALLOWED_ARCHIVE_AFTER_X_DAYS = 1;
exports.DEVICE_ID_COOKIE_FIELD = "deviceId";
exports.CHANGE_HISTORY_RETENTION_PERIOD_IN_YEARS = 10;
exports.DEFAULT_CSV_DECIMAL_SEPARATOR = userSettings_interface_1.CsvNumberDecimalSeparatorTypeEnum.COMMA;
exports.COLLECTIONS_WITH_CHANGE_HISTORY = [
    collectionName_enum_1.CollectionNameEnum.EXPENSE,
    collectionName_enum_1.CollectionNameEnum.USER,
    collectionName_enum_1.CollectionNameEnum.MATCHING_TRANSACTION,
    collectionName_enum_1.CollectionNameEnum.COMPANY_SETTINGS,
    collectionName_enum_1.CollectionNameEnum.VENDOR,
    collectionName_enum_1.CollectionNameEnum.ROLE,
    collectionName_enum_1.CollectionNameEnum.WALLET,
    collectionName_enum_1.CollectionNameEnum.BANK_CONNECTION,
    collectionName_enum_1.CollectionNameEnum.COST_CENTER_2,
    collectionName_enum_1.CollectionNameEnum.CARD,
    collectionName_enum_1.CollectionNameEnum.CORPORATE,
    collectionName_enum_1.CollectionNameEnum.COST_CENTER,
    collectionName_enum_1.CollectionNameEnum.EXPENSE_TAG,
    collectionName_enum_1.CollectionNameEnum.INBOX_INVOICE,
    collectionName_enum_1.CollectionNameEnum.TAX,
    collectionName_enum_1.CollectionNameEnum.TEAM,
    collectionName_enum_1.CollectionNameEnum.WORKFLOW,
    collectionName_enum_1.CollectionNameEnum.CSV_TEMPLATE,
    collectionName_enum_1.CollectionNameEnum.EXPENSE_ACCOUNT,
];
exports.CSV_EMPTY_VALUE = "";
exports.FINWAY_LEGAL_DATA = Object.freeze({
    name: "finway GmbH",
    street: "Landsberger Str. 155 / Haus 1",
    email: "info@finway.de",
    zip: "80687",
    city: "München",
    phone: "089 380 37708",
});
